"use strict";

$(document).ready(function () {
  var $toolbar = $(".toolbar");
  if ($toolbar.length === 0) {
    return;
  }
  var stickitLeft = $toolbar.offset.left;
  var stickitHeight = $toolbar.height() + "px";
  var stickySidebarToTop = $toolbar.offset().top;
  $(window).scroll(function () {
    var windowToTop = $(window).scrollTop();
    var $toolbarDesktop = $(".toolbar-desktop");
    if (windowToTop + 10 + 116 > stickySidebarToTop) {
      $toolbarDesktop.css({
        position: "fixed",
        top: "126px",
        left: stickitLeft,
        height: stickitHeight
      });
    } else {
      $toolbarDesktop.removeAttr("style");
    }
  });
  $(".toolbar-mobile").click(function (e) {
    $(".toolbar-box.help").toggleClass("open");
  });
  $(".toolbar-box.mobile").click(function (e) {
    e.stopPropagation();
    if (e.target.id !== "switchRoundedDefault" && e.target.getAttribute("for") !== 'switchRoundedDefault') {
      $(this).toggleClass("active");
    }
  });
  var contrastCheckboxDesktop = document.querySelector('.desktop-input');
  if (contrastCheckboxDesktop) {
    contrastCheckboxDesktop.addEventListener("change", function (e) {
      document.body.classList.toggle("contrast");
    });
  }
  var contrastCheckboxMobile = document.querySelector('.mobile-input');
  if (contrastCheckboxMobile) {
    contrastCheckboxMobile.addEventListener("change", function (e) {
      document.body.classList.toggle("contrast");
    });
  }
  var mobileToolbox = document.querySelector(".toolbar-box.mobile");
  var contrastLabel = mobileToolbox.querySelector("label[for='switchRoundedDefault']");
  var contrastInput = document.querySelector('.contrast-checkbox');
  if (contrastLabel) {
    contrastLabel.addEventListener("click", function () {
      var clickEvent = new Event("click");
      contrastCheckboxMobile.dispatchEvent(clickEvent);
    });
  }
});